var styles = {
  "Header": "Online-Store-UI-Header_1doc8",
  "Content": "Online-Store-UI-Header__Content_1nqya",
  "hasBackArrow": "Online-Store-UI-Header--hasBackArrow_sfwmr",
  "hasRightCloseAction": "Online-Store-UI-Header--hasRightCloseAction_cw9yf",
  "hasRollupMenu": "Online-Store-UI-Header--hasRollupMenu_s2abo",
  "PrefixTitleWrapper": "Online-Store-UI-Header__PrefixTitleWrapper_ivx08",
  "Prefix": "Online-Store-UI-Header__Prefix_1ju98",
  "Title": "Online-Store-UI-Header__Title_67sx3",
  "TitleHeading": "Online-Store-UI-Header__TitleHeading_1rvcy",
  "strong": "Online-Store-UI-Header--strong_1px28",
  "Subtitle": "Online-Store-UI-Header__Subtitle_jh9s0",
  "CloseAction": "Online-Store-UI-Header__CloseAction_wkxcv",
  "RollupMenuWrapper": "Online-Store-UI-Header__RollupMenuWrapper_413u7"
};

export { styles as default };
